import useSWRImmutable from 'swr/immutable';
import { fetcherSS } from '@/modules/api';

export interface IPlayerFields {
  contexts: { [key: string]: string[] };
  fields: {
    field: string;
    type: string;
    length?: {
      minimum?: number;
      maximum?: number;
    };
    onceSet?: boolean;
    age?: any;
    inclusion?: any;
    service?: string;
  }[];
}

export const usePlayerFields = () => {
  const { data, error, isLoading } = useSWRImmutable<IPlayerFields>(
    '/info/player_fields',
    (url: string) => fetcherSS(url, { headers: { 'X-Content-Policy': '4' } })
  );

  return {
    data,
    error,
    isLoading,
  };
};
